(() => {
  if (window.gvBf2026Ready) return;
  window.gvBf2026Ready = true;
  const timers = new Map();
  function init(root) {
    root.querySelectorAll('[data-gv-schedule]').forEach(schedule => {
      if (timers.has(schedule)) return;
      const clock = schedule.querySelector('[data-gv-clock]');
      const end = Date.parse(schedule.dataset.target);
      if (!clock || !Number.isFinite(end)) return;
      const update = () => {
        const total = Math.floor((end - Date.now()) / 1000);
        if (!schedule.isConnected || total <= 0) {
          clock.hidden = true; clearInterval(timers.get(schedule)); timers.delete(schedule); return;
        }
        const values = [Math.floor(total / 86400),Math.floor(total / 3600) % 24,Math.floor(total / 60) % 60,total % 60];
        ['days','hours','minutes','seconds'].forEach((part,i) => clock.querySelector('[data-gv-' + part + ']').textContent = String(values[i]).padStart(2,'0'));
        clock.hidden = false;
      };
      timers.set(schedule,setInterval(update,1000)); update();
    });
  }
  function activate(tab) {
    const isPhase = tab.hasAttribute('data-gv-phase');
    const root = tab.closest(isPhase ? '[data-gv-schedule]' : '[data-gv-products]');
    const selector = isPhase ? '[data-gv-phase]' : '[data-gv-tab]';
    root.querySelectorAll(selector).forEach(t => { const selected = t === tab; t.setAttribute('aria-selected',String(selected));t.tabIndex = selected ? 0 : -1; });
    root.querySelectorAll('[role="tabpanel"]').forEach(panel => panel.hidden = panel.id !== tab.getAttribute('aria-controls'));
  }
  document.addEventListener('click',async event => {
    const tab = event.target.closest('[data-gv-tab],[data-gv-phase]');
    if (tab) activate(tab);
    const copy = event.target.closest('[data-gv-copy]');
    if (copy) {
      const label = copy.querySelector('[data-gv-copy-label]');
      try {
        await navigator.clipboard.writeText(copy.dataset.gvCopy);
        label.textContent = 'Kopiert ✓';
        const status = document.querySelector('[data-gv-status]');
        if (status) status.textContent = 'Gutscheincode ' + copy.dataset.gvCopy + ' kopiert.';
        setTimeout(() => { if (label.isConnected) label.textContent = 'Code kopieren'; },3000);
      } catch { label.textContent = copy.dataset.gvCopy; }
    }
    if (event.target.closest('[data-gv-top]')) window.scrollTo({top:0,behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
  });
  document.addEventListener('keydown',event => {
    const tab = event.target.closest('[data-gv-tab],[data-gv-phase]');
    if (!tab || !['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
    event.preventDefault();
    const tabs = [...tab.closest('[role="tablist"]').querySelectorAll('[role="tab"]')], index = tabs.indexOf(tab);
    const next = event.key === 'Home' ? 0 : event.key === 'End' ? tabs.length-1 : (index+(event.key==='ArrowRight'?1:-1)+tabs.length)%tabs.length;
    activate(tabs[next]);tabs[next].focus();
  });
  init(document);
  document.addEventListener('shopify:section:load',e => init(e.target));
  document.addEventListener('shopify:section:unload',() => { for (const [root,timer] of timers) if (!root.isConnected) { clearInterval(timer);timers.delete(root); } });
  const up = document.querySelector('[data-gv-top]');
  if (up) { const update = () => up.hidden = window.scrollY < 700;window.addEventListener('scroll',update,{passive:true});update(); }
})();
